// extracted by mini-css-extract-plugin
export default {"section-title-icon":"_28D9k","sectionTitleIcon":"_28D9k"};